import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { FC } from 'react';
import { TablePDF } from './TablePDF';
import { TITLE_COLOR } from '../consts';

const styles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: '100%',
	},
	title: {
		fontSize: 14,
		color: TITLE_COLOR,
		marginBottom: 4,
	},
});

export const Page2: FC = () => {
	return (
		<View style={styles.container}>
			<View>
				<Text style={styles.title}>Methodology</Text>
				<Text>
					Denominator performance assessment is based upon internationally recognized frameworks and covers multiple diversity dimensions across board of directors, executive team, and
					the company level. The scores go from 0-100 with 0 being the lowest and 100 being the highest. Conversion of performance into absolute and relative ratings are as per below
					tables.
				</Text>
			</View>

			<TablePDF<'scoreInterval' | 'absoluteRating'>
				columns={[
					{
						id: 'scoreInterval',
						name: 'Score interval',
					},
					{
						id: 'absoluteRating',
						name: 'Absolute rating',
					},
				]}
				data={[
					{
						item: {
							scoreInterval: '87-100',
							absoluteRating: 'A***',
						},
					},
					{
						item: {
							scoreInterval: '73-86',
							absoluteRating: 'A**',
						},
					},
					{
						item: {
							scoreInterval: '58-72',
							absoluteRating: 'A*',
						},
					},
					{
						item: {
							scoreInterval: '43-57',
							absoluteRating: 'B***',
						},
					},
					{
						item: {
							scoreInterval: '28-42',
							absoluteRating: 'B**',
						},
					},
					{
						item: {
							scoreInterval: '14-27',
							absoluteRating: 'B*',
						},
					},
					{
						item: {
							scoreInterval: '0-13',
							absoluteRating: 'C*',
						},
					},
				]}
			/>

			<TablePDF<'industryQuartile' | 'countryQuartile' | 'relativeQuartile'>
				columns={[
					{
						id: 'industryQuartile',
						name: 'Industry quartile',
					},
					{
						id: 'countryQuartile',
						name: 'Country quartile',
					},
					{
						id: 'relativeQuartile',
						name: 'Relative rating',
					},
				]}
				data={[
					{
						item: {
							industryQuartile: 'Top quartile',
							countryQuartile: 'Top quartile',
							relativeQuartile: 'A***',
						},
					},
					{
						item: {
							industryQuartile: 'Top quartile',
							countryQuartile: 'Above median',
							relativeQuartile: 'A**',
						},
						meta: { isBorderDisabled: true },
					},
					{
						item: {
							industryQuartile: 'Above median',
							countryQuartile: 'Top quartile ',
							relativeQuartile: 'A**',
						},
					},
					{
						item: {
							industryQuartile: 'Top quartile',
							countryQuartile: 'Below median',
							relativeQuartile: 'A*',
						},
						meta: { isBorderDisabled: true },
					},
					{
						item: {
							industryQuartile: 'Below median',
							countryQuartile: 'Top quartile',
							relativeQuartile: 'A*',
						},
						meta: { isBorderDisabled: true },
					},
					{
						item: {
							industryQuartile: 'Above median',
							countryQuartile: 'Above median',
							relativeQuartile: 'A*',
						},
					},
					{
						item: {
							industryQuartile: 'Above median',
							countryQuartile: 'Below median',
							relativeQuartile: 'B***',
						},
						meta: { isBorderDisabled: true },
					},
					{
						item: {
							industryQuartile: 'Below median',
							countryQuartile: 'Above median',
							relativeQuartile: 'B***',
						},
						meta: { isBorderDisabled: true },
					},
					{
						item: {
							industryQuartile: 'Top quartile',
							countryQuartile: 'Bottom quartile',
							relativeQuartile: 'B***',
						},
						meta: { isBorderDisabled: true },
					},
					{
						item: {
							industryQuartile: 'Bottom quartile',
							countryQuartile: 'Top quartile',
							relativeQuartile: 'B***',
						},
					},
					{
						item: {
							industryQuartile: 'Below median',
							countryQuartile: 'Below median',
							relativeQuartile: 'B**',
						},
						meta: { isBorderDisabled: true },
					},
					{
						item: {
							industryQuartile: 'Above median',
							countryQuartile: 'Bottom quartile',
							relativeQuartile: 'B**',
						},
						meta: { isBorderDisabled: true },
					},
					{
						item: {
							industryQuartile: 'Bottom quartile',
							countryQuartile: 'Above median',
							relativeQuartile: 'B**',
						},
					},
					{
						item: {
							industryQuartile: 'Below median',
							countryQuartile: 'Bottom quartile',
							relativeQuartile: 'B*',
						},
						meta: { isBorderDisabled: true },
					},
					{
						item: {
							industryQuartile: 'Bottom quartile',
							countryQuartile: 'Below median',
							relativeQuartile: 'B*',
						},
					},
					{
						item: {
							industryQuartile: 'Bottom quartile',
							countryQuartile: 'Bottom quartile',
							relativeQuartile: 'C*',
						},
					},
				]}
			/>
		</View>
	);
};
